import { Row } from '@/components/Theme/Row';
import { ThemeRow } from '@/components/Theme/ThemeRow';
import { ThemeText } from '@/components/Theme/ThemeText';
import { FormatPrice } from '@/elements/Product/Price';
import isEqual from 'lodash/isEqual';
import { memo } from 'react';

export const TextRow = memo((props) => {
    let {
        value = 0
    } = props ?? {};
    
    const { 
        row, 
        small = null, 
        showFree = true,
        leftProps = {},
        rightProps = {}, 
        rowProps = {},
        leftRowProps = {}
    } = props ?? {};

    if (isNaN(value)) 
        value = 0;

    return (
        <ThemeRow justifyContent={'space-between'} alignItems={'center'} {...rowProps}>
            <Row flex={1} gap={5} alignItems={'center'} {...leftRowProps}>
                <ThemeText variant={['h2']} id={row} {...leftProps} />
                {small && (
                    typeof small === 'string' ? <ThemeText variant={['small']} prepend={'('} append={')'} id={small} />
                    : small
                )}
            </Row>

            {value == 0 && showFree 
            ?   <ThemeText variant={'regular'} id={'global.free'} {...rightProps} />
            :   <FormatPrice
                    price={value || 0}
                    currency={'EUR'}
                    variant={'regular'}
                    {...rightProps}
                />
            }
        </ThemeRow>
    )
}, isEqual);